import classNames from 'classnames';
import React, { ReactNode, useState } from 'react';
import { Collapse as CollapseReact } from 'reactstrap';

interface PropTypes {
  children: ReactNode;
  elements: JSX.Element[];
  className?: string;
  collapseClassName?: string;
}

export function Collapse(props: PropTypes) {
  const [isOpen, setOpen] = useState(false);

  return (
    <>
      <div
        onClick={() => setOpen(!isOpen)}
        className={classNames(
          'd-flex justify-content-between align-items-center fs-5 cursor-pointer',
          props.className,
        )}
      >
        {props.children}
        <i className={`bi bi-chevron-${isOpen ? 'up' : 'down'}`} />
      </div>
      <CollapseReact className={props.collapseClassName} isOpen={isOpen}>
        {props.elements}
      </CollapseReact>
    </>
  );
}
